
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRank2 as ObiRank2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-rank-2.js';
 
 
 

 
 export const ObiRank2 = createComponent({
   react: React,
   tagName: 'obi-rank-2',
   elementClass: ObiRank2Element,
   events: {
     
   }
  });
 
 